import React, { useEffect } from 'react';

import { Lock150Icon } from 'public/assets/icons';
import { IPrivateContentModal } from './IPrivateContentModal';
import {
  ContentWrap,
  ModalWrap,
  HeaderText,
  BodyText,
} from './PrivateContentModal.style';
import Button from 'components/common/Button';
import { style } from 'utils/constants/style';

export const PrivateContentModal = ({
  headerText,
  bodyText,
  showButton,
  buttonText,
  onButtonClick,
}: IPrivateContentModal) => {
  useEffect(() => {}, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.overflowX = 'hidden';
    };
  }, []);

  return (
    <ContentWrap onClick={() => {}}>
      <ModalWrap onClick={() => {}}>
        <Lock150Icon />
        <HeaderText>{headerText}</HeaderText>
        <BodyText>{bodyText}</BodyText>
        {showButton && (
          <Button htmlType="submit" variant="primary" onClick={onButtonClick}>
            {buttonText}
          </Button>
        )}
      </ModalWrap>
    </ContentWrap>
  );
};
